import React, { useState, useEffect } from "react";
import "../styles/vote_card.css";

export default function Vote_card_component({
    match,
    stats,
    setStats,
    vote1x2,
    setVote1x2,
    voteBtts,
    setVoteBtts,
    voteOver25,
    setVoteOver25,
    voteCards,
    setVoteCards,
    saveVote,
    addToast
}) {
    const [open, setOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("vote");

    const [hasVoted, setHasVoted] = useState(false)

    const [comments, setComments] = useState([]);
    const [inputComment, setInputComment] = useState("");

    const {
        id: matchId,
        league_logo_url,
        league_name,
        league_nation,
        start_time,
        home_team_logo_url,
        home_team_name,
        away_team_logo_url,
        away_team_name
    } = match;


    //FELHASZNÁLÓ SZAVAZOTT E MÁR?
    useEffect(() => {
        fetch(`https://focifanatik.hu/api/has_voted.php?id=${matchId}`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => setHasVoted(data.voted));
    }, [matchId]);



    //KOMMENT HOZZÁADÁSA
    const addComment = () => {
        if (inputComment.trim() === "") return;

        fetch("https://focifanatik.hu/api/add_comment.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                match_id: matchId,
                text: inputComment
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    addToast("Komment elküldve!", "success")
                    setInputComment("");

                    fetch(`https://focifanatik.hu/api/get_comments.php?id=${matchId}`)
                        .then(r => r.json())
                        .then(d => setComments(d));
                } else {
                    addToast(data.error, "warning");
                }
            })
            .catch(() => addToast("Hálózati hiba!", "warning"));
    };

    //STATISZTIKA FRISSITÉS
    useEffect(() => {
        if (open && hasVoted) {
            fetch(`https://focifanatik.hu/api/vote_stats.php?id=${matchId}`)
                .then(res => res.json())
                .then(statData => {
                    setStats(prev => ({
                        ...prev,
                        [matchId]: statData
                    }));
                });
        }
    }, [open, hasVoted, matchId]);


    //KOMMENTEK BETÖLTÉSE
    useEffect(() => {
        // FONTOS: pontos URL
        fetch(`https://focifanatik.hu/api/get_comments.php?id=${matchId}`)
            .then((response) => response.json())
            .then((data) => {
                console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
                setComments(data);
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [matchId]);

    const percent = (part, total) =>
        total === 0 ? 0 : Math.round((part / total) * 100);

    return (
        <div className="match-card">

            {/* ------------ HEADER ------------ */}
            <div className="match-header">
                <img src={`/images/leagues/${league_logo_url}`} alt={league_name} className="league-logo" />

                <div className="header-center">
                    <h4 className="league-title">{league_name}</h4>
                    <p className="league-nation">{league_nation}</p>
                </div>

                <div className="match-date-box">
                    <b>{start_time}</b>
                </div>
            </div>

            {/* ------------ BODY ------------ */}
            <div className="match-body">

                <div className="team">
                    <img src={`/images/teams/${home_team_logo_url}`} alt={home_team_name} className="team-logo" />
                    <p className="team-name">{home_team_name}</p>
                </div>

                <div className="vs">VS</div>

                <div className="team">
                    <img src={`/images/teams/${away_team_logo_url}`} alt={away_team_name} className="team-logo" />
                    <p className="team-name">{away_team_name}</p>
                </div>
            </div>

            {/* ------------ EXPAND BUTTON ------------ */}
            <button className="expand-btn" onClick={() => setOpen(!open)}>
                {open ? "▲ Bezárás" : "▼ Tippjáték / Komment"}
            </button>


            {/* ------------ EXPAND CONTENT ------------ */}
            {open && (
                <div className="expand-content">

                    {/* TABOK */}
                    <div className="tabs">
                        <button
                            className={activeTab === "vote" ? "tab active" : "tab"}
                            onClick={() => setActiveTab("vote")}
                        >
                            Tippjáték
                        </button>

                        <button
                            className={activeTab === "comments" ? "tab active" : "tab"}
                            onClick={() => setActiveTab("comments")}
                        >
                            Kommentek
                        </button>
                    </div>

                    {/* ------------ TAB: TIPPEK ------------ */}
                    {activeTab === "vote" && (
                        <>
                            {!hasVoted ? (
                                <>
                                    <div className="vote-section">

                                        {/* ---- 1X2 ---- */}
                                        <div className="vote-block">
                                            <h5>⚽ Melyik csapat fog nyerni? (1X2)</h5>
                                            <div className="vote-options">
                                                <button
                                                    className={vote1x2 === "home" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVote1x2("home")}
                                                >
                                                    {home_team_name}
                                                </button>

                                                <button
                                                    className={vote1x2 === "X" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVote1x2("X")}
                                                >
                                                    Döntetlen
                                                </button>

                                                <button
                                                    className={vote1x2 === "away" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVote1x2("away")}
                                                >
                                                    {away_team_name}
                                                </button>
                                            </div>
                                        </div>

                                        {/* ---- BTTS ---- */}
                                        <div className="vote-block">
                                            <h5>🥅 Mindkét csapat szerez gólt?</h5>
                                            <div className="vote-options">
                                                <button
                                                    className={voteBtts === "yes" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteBtts("yes")}
                                                >
                                                    Igen
                                                </button>

                                                <button
                                                    className={voteBtts === "no" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteBtts("no")}
                                                >
                                                    Nem
                                                </button>
                                            </div>
                                        </div>

                                        {/* ---- Over 2.5 ---- */}
                                        <div className="vote-block">
                                            <h5>⚽ Gólok száma 2.5 felett?</h5>
                                            <div className="vote-options">
                                                <button
                                                    className={voteOver25 === "over" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteOver25("over")}
                                                >
                                                    Igen
                                                </button>

                                                <button
                                                    className={voteOver25 === "under" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteOver25("under")}
                                                >
                                                    Nem
                                                </button>
                                            </div>
                                        </div>

                                        {/* ---- LAPOK ---- */}
                                        <div className="vote-block">
                                            <h5>🟨 Lapok száma 2.5 felett?</h5>
                                            <div className="vote-options">
                                                <button
                                                    className={voteCards === "over" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteCards("over")}
                                                >
                                                    Igen
                                                </button>

                                                <button
                                                    className={voteCards === "under" ? "vote-btn active" : "vote-btn"}
                                                    onClick={() => setVoteCards("under")}
                                                >
                                                    Nem
                                                </button>
                                            </div>
                                        </div>


                                    </div>

                                    {/* ---- KÜLDÉS ---- */}
                                    <div className="vote-submit-box">
                                        <button
                                            className="vote-submit-btn"
                                            disabled={!vote1x2 || !voteBtts || !voteOver25 || !voteCards}
                                            onClick={() => {
                                                saveVote(match.id);
                                                setHasVoted(true);
                                            }}
                                        >
                                            Szavazat elküldése
                                        </button>
                                    </div>
                                </>
                            ) : (
                                stats && stats["1x2"] ? (
                                    <div className="vote-stats mt-4">
                                        <h5 className="stats-main-title">📊 Szavazati statisztika</h5>

                                        {/* ===== 1X2 MARAD ===== */}
                                        <div className="stats-block">
                                            <h6 className="stats-center-title">⚽ Melyik csapat fog nyerni? (1X2)</h6>

                                            <div className="stats-1x2-grid">
                                                {[
                                                    {
                                                        label: home_team_name,
                                                        value: stats["1x2"].home,
                                                        color: "green"
                                                    },
                                                    {
                                                        label: "Döntetlen",
                                                        value: stats["1x2"].X,
                                                        color: "gray"
                                                    },
                                                    {
                                                        label: away_team_name,
                                                        value: stats["1x2"].away,
                                                        color: "red"
                                                    }
                                                ].map((item, i) => {
                                                    const total =
                                                        stats["1x2"].home +
                                                        stats["1x2"].X +
                                                        stats["1x2"].away;

                                                    return (
                                                        <div className="stats-item" key={i}>
                                                            <span className="stats-label">{item.label}</span>
                                                            <div className="bar">
                                                                <div
                                                                    className={`bar-fill ${item.color}`}
                                                                    style={{
                                                                        width: `${percent(item.value, total)}%`
                                                                    }}
                                                                />
                                                            </div>
                                                            <span className="stats-percent">
                                                                {percent(item.value, total)}%
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {/* ===== BTTS ===== */}
                                        {(() => {
                                            const yes = stats.btts.yes;
                                            const no = stats.btts.no;
                                            const total = yes + no;
                                            const winner = yes >= no ? "Igen" : "Nem";
                                            const value = Math.max(yes, no);

                                            return (
                                                <div className="stats-block">
                                                    <h6 className="stats-center-title">
                                                        🥅 Mindkét csapat szerez gólt?
                                                    </h6>

                                                    <div className="stats-single">
                                                        <span className="stats-winner">{winner}</span>
                                                        <div className="bar big">
                                                            <div
                                                                className="bar-fill green"
                                                                style={{
                                                                    width: `${percent(value, total)}%`
                                                                }}
                                                            />
                                                        </div>
                                                        <span className="stats-percent">
                                                            {percent(value, total)}%
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })()}

                                        {/* ===== OVER / UNDER ===== */}
                                        {(() => {
                                            const over = stats.over25.over;
                                            const under = stats.over25.under;
                                            const total = over + under;
                                            const winner = over >= under ? "2.5 Felett" : "2.5 Alatt";
                                            const value = Math.max(over, under);

                                            return (
                                                <div className="stats-block">
                                                    <h6 className="stats-center-title">
                                                        ⚽ Gólok száma (2.5)
                                                    </h6>

                                                    <div className="stats-single">
                                                        <span className="stats-winner">{winner}</span>
                                                        <div className="bar big">
                                                            <div
                                                                className="bar-fill green"
                                                                style={{
                                                                    width: `${percent(value, total)}%`
                                                                }}
                                                            />
                                                        </div>
                                                        <span className="stats-percent">
                                                            {percent(value, total)}%
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })()}

                                        {/* ===== CARDS ===== */}
                                        {(() => {
                                            const over = stats.cards.over;
                                            const under = stats.cards.under;
                                            const total = over + under;
                                            const winner = over >= under ? "2.5 Felett" : "2.5 Alatt";
                                            const value = Math.max(over, under);

                                            return (
                                                <div className="stats-block">
                                                    <h6 className="stats-center-title">
                                                        🟨 Lapok száma (2.5)
                                                    </h6>

                                                    <div className="stats-single">
                                                        <span className="stats-winner">{winner}</span>
                                                        <div className="bar big">
                                                            <div
                                                                className="bar-fill green"
                                                                style={{
                                                                    width: `${percent(value, total)}%`
                                                                }}
                                                            />
                                                        </div>
                                                        <span className="stats-percent">
                                                            {percent(value, total)}%
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>

                                ) : (
                                    <p className="text-muted">Statisztika betöltése...</p>
                                )
                            )}
                        </>
                    )}

                    {/* ------------ TAB: KOMMENT ------------ */}
                    {activeTab === "comments" && (
                        <div className="comment-section">

                            {/* Input */}
                            <div className="comment-input-box">
                                <input
                                    type="text"
                                    value={inputComment}
                                    onChange={(e) => setInputComment(e.target.value)}
                                    placeholder="Írj egy kommentet..."
                                    className="comment-input"
                                />
                                <button className="comment-send" onClick={addComment}>
                                    Küldés
                                </button>
                            </div>

                            {/* Kommentek */}
                            <div className="comment-list">
                                {comments.length === 0 ? (
                                    <p className="no-comments">Még nincs hozzászólás</p>
                                ) : (
                                    comments.map((c) => (
                                        <div className="comment-item" key={c.id}>
                                            <div className="comment-header">
                                                <span className="comment-user">{c.username}</span>
                                                {/* később: <span className="comment-date">2025.01.12</span> */}
                                            </div>
                                            <div className="comment-text">{c.text}</div>
                                        </div>
                                    ))
                                )}
                            </div>

                        </div>
                    )}


                </div>
            )}

        </div>
    );
}
